import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import moment from 'moment';
import './filters';

// Vue2Filters https://www.npmjs.com/package/vue2-filters
Vue.use(Vue2Filters);

Vue.filter('truncate', function (text, stop) {
    return text.slice(0, stop) + '...';
});

Vue.filter('formatDate', function(date) {
    return moment(date).format('MM.DD.YYYY');
});

Vue.filter('formatTime', (date) => {
    return moment(date).format('hh:mm:ss A');
});

Vue.filter('formatDateTime', function(date) {
    return moment(date).format('MM.DD.YYYY HH:mm:ss');
});

Vue.filter('formatDateTimeHuman', function(date) {
    date += '+00:00';
    return moment(date).local().fromNow();
});

Vue.filter('formatCalendar', function(date) {
    return moment(date).calendar();
});

Vue.filter('formatSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB';
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB';
    }
    return size.toString() + ' B';
});

Vue.filter('localDateTime', function (date) {
    date += '+00:00';
    return moment(date).local().format('MM.DD.YYYY hh:mm:ss A');
});

Vue.filter('status', (status, type) => {
    let cls, st;
    switch (status) {
        case -2:
            st = 'Cancelled';
            cls = 'badge-danger';
            break;
        case -1:
            st = 'Declined';
            cls = 'badge-danger';
            break;
        case 0:
            st = 'Pending';
            cls = 'badge-warning';
            break;
        case 1:
            st = 'Active';
            cls = 'badge-success';
            break;
    }
    if (type === 'class') {
        return cls;
    }
    return st;
});